
const createHistory = require("history").createBrowserHistory;

  export const redirectToLogout = () => {
    let history = createHistory();
    history.push("/auth/login");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  // Clears the stored session and sends the user back to the login screen. Used when
  // the API reports that the token is no longer valid, which happens on any terminal
  // left signed in past the token's one-week life.
  export const endExpiredSession = () => {
    localStorage.setItem("token", null);
    localStorage.setItem("username", null);
    localStorage.setItem("userId", null);
    localStorage.setItem("userRole", null);
    redirectToLogout();
  };

  // The API answers HTTP 200 even when it refuses a call — the refusal is in the body
  // as result.code < 0 (-2 = authentication required), with data: null. Reading `.data`
  // straight off such a response yields an empty screen that looks like "no records"
  // rather than an error, so every caller should unwrap through here.
  export const unwrapApiData = (responseData) => {
    const code = responseData && responseData.result && responseData.result.code;
    if (code != null && code < 0) {
      if (code === -2) {
        endExpiredSession();
        throw new Error("Your session has expired. Please log in again.");
      }
      throw new Error((responseData.result && responseData.result.description) || "Request failed");
    }
    return responseData && responseData.data !== undefined ? responseData.data : responseData;
  };


  export const getDayIdText = (dayId) => {
    switch (dayId) {
      case 1:
        return "Sunday"; 
      case 2:
        return "Monday";
      case 3:
        return "Tuesday";
      case 4:
        return "Wednesday";
      case 5:
        return "Thursday";
      case 6:
        return "Friday";
      case 7:
        return "Saturday";
    }
  }

  export const getYesNoFromInt = (value) => {
    if(value == 1){
      return "Yes";
    }
    return "No";
  }

  export const parseWashingFeatures = (info) => {
    try{
    if(info.defaultWashingFeatures != null && info.defaultWashingFeatures != ''){
      info.washingFeaturesNeat = JSON.parse(info.defaultWashingFeatures);
    }
    else if(info.washingFeatures != null && info.washingFeatures != ''){
      info.washingFeaturesNeat = JSON.parse(info.washingFeatures);
    }
    else{
      return info;
    }
      // Newer app builds send the tenant's own scent name with the id.
      if(info.washingFeaturesNeat.scentName){
        info.scent = info.washingFeaturesNeat.scentName;
      }
      else switch(info.washingFeaturesNeat.scent){
        case 0:
          info.scent = "Fresh";
          break;
        case 1:
          info.scent = "Oud";
            break;
        case 2:
          info.scent = "Rose";
          break;
        case 3:
          info.scent = "Vanilla";
          break;
        case 99:
          info.scent = "no scent";
            break;
        default:
          info.scent = "None";
          break;
      }
      switch(info.washingFeaturesNeat.starch){
        case 0:
          info.starch = "Light";
          break;
        case 1:
          info.starch = "Medium";
            break;
          case 2:
              info.starch = "Heavy";
                break;
        default:
          info.starch = "None";
          break;
      }
      // switch(info.washingFeaturesNeat.thobeBackCrease){
      //   case false:
      //     info.thobeBackCrease = "No";
      //     break;
      //   case true:
      //     info.thobeBackCrease = "Yes";
      //       break;
      //   default:
      //     info.thobeBackCrease = "None";
      //     break;
      // }

      switch(info.washingFeaturesNeat.ghetra){
        case 0:
          info.ghetra = "Square";
          break;
        case 1:
          info.ghetra = "Triangle";
            break;
        default:
          info.ghetra = "None";
          break;
      }
      // switch(info.washingFeaturesNeat.shirtsSleeveCrease){
      //   case false:
      //     info.shirtsSleeveCrease = "No";
      //     break;
      //   case true:
      //     info.shirtsSleeveCrease = "Yes";
      //       break;
      //   default:
      //     info.shirtsSleeveCrease = "None";
      //     break;
      // }
      // switch(info.washingFeaturesNeat.pantsTravelersCrease){
      //   case false:
      //     info.pantsTravelersCrease = "No";
      //     break;
      //   case true:
      //     info.pantsTravelersCrease = "Yes";
      //       break;
      //   default:
      //     info.pantsTravelersCrease = "None";
      //     break;
      // }
      return info;
    }
    catch (ex) {
      return info;
    }
}

export const isSaudi = () => {
  return localStorage.getItem("selectedCountry") === "2";
}
    
export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank");
  if (newWindow) newWindow.opener = null
}

export const getIsPickedFromLaundry = (order) => {
  if(order == null || order.qrTagsById == null){
    return false;
  }
    var containsLaundryQrs = false, hasUnpickedBags = false;
    for(var i=0;i<order.qrTagsById.length;i++){
        if(order.qrTagsById[i].flow == 1){
          containsLaundryQrs = true;
          if(order.qrTagsById[i].isPickedUp == 0){
            hasUnpickedBags = true;
            break;
          }
        }
    }
    if(containsLaundryQrs && !hasUnpickedBags){
      return true;
    }
    return false;
}

export function zeroFill( number, width )
{
  width -= number.toString().length;
  if ( width > 0 )
  {
    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
  }
  return number + ""; // always return a string
}

export function numericSortFunc(a, b, order, dataField, rowA, rowB) {
  if (order === 'desc') {
    return Number(b) - Number(a);
  }
    return Number(a) - Number(b);
}

export function dateSortFunc(a, b, order, dataField, rowA, rowB) {
  if (order === 'desc') {
    return Date.parse(b) - Date.parse(a);
  }  
    return Date.parse(a) - Date.parse(b);
}

export function slotDateSortFunc(a, b, order, dataField, rowA, rowB) {
  if (order === 'desc') {
    return Date.parse(b.split(" - ")[0]) - Date.parse(a.split(" - ")[0]);
  }  
    return Date.parse(a.split(" - ")[0]) - Date.parse(b.split(" - ")[0]);
}

export function dateOnlySortFunc(a, b, order, dataField, rowA, rowB) {
  if (order === 'desc') {
    return Date.parse(b+" 00:00 AM") - Date.parse(a+" 00:00 AM");
  }  
    return Date.parse(a+" 00:00 AM") - Date.parse(b+" 00:00 AM");
}

export const getOrderStatusCode = (text) => {
  switch (text) {
    case "Freeze Cancelled": return -4;
    case "Not Renewed": return -3;
    case "Order Cancelled": return -2;
    case "Payment Failed": return -1;
    case "Pending Payment": return 0;
    case "Order Placed": return 1;
    case "Out for Pickup": return 2;
    case "Picked Up": return 3;
    case "Washing": return 4;
    case "Washed": return 5;
    case "Out for Delivery": return 6;
    case "Delivered": return 7;
    case "Customer Not Available for Pickup": return 8;
    case "Customer Not Available for Drop off": return 9;
    case "On Hold": return 10;
    default: return null;
  }
};


export const extractOrderId = (rawId) => {
  return rawId
    .replace(/^P/, '')        // Remove leading 'P'
    .replace(/^0+/, '')       // Remove leading zeros
    .replace(/-.*/, '');      // Remove dash and anything after
}

